// internal
import { axios, def, handleResponse, handleError } from './internal';

function Setting(path, value, setData) {
    setData?.((prev) => ({ ...prev, loading: true }));
    axios
        .post('/api/setting', {
            path,
            value,
        })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        })
        .finally(() => setData?.((prev) => ({ ...prev, loading: false })));
}

export { Setting };
